import React from 'react';
import PropTypes from 'prop-types';

// import components
import ComparePopupTop from '@/kenwood/components/molecules/ComparePopupTop';
import ComparePopupContent from '@/kenwood/components/molecules/ComparePopupContent';

const ComparePopup = ({
  productsCode,
  data,
  isOpen,
  showDifferences,
  titleLabel,
  viewLabel,
  buyLabel,
  seeDifferencesLabel,
  resultsGeneralSpecsLabel,
  resultsIdLabel,
  onClosePopup,
  onPopProduct,
  onToggleShowDifferences,
}) => (
  <section className={`ken-compare__popup ${isOpen ? '--open' : ''}`}>
    <ComparePopupTop titleLabel={titleLabel} onClosePopup={onClosePopup} />
    <ComparePopupContent
      productsCode={productsCode}
      products={data.products}
      results={data.results}
      showDifferences={showDifferences}
      viewLabel={viewLabel}
      buyLabel={buyLabel}
      seeDifferencesLabel={seeDifferencesLabel}
      resultsGeneralSpecsLabel={resultsGeneralSpecsLabel}
      resultsIdLabel={resultsIdLabel}
      onPopProduct={onPopProduct}
      onToggleShowDifferences={onToggleShowDifferences}
    />
  </section>
);

ComparePopup.propTypes = {
  productsCode: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.shape(),
  isOpen: PropTypes.bool,
  showDifferences: PropTypes.bool,
  titleLabel: PropTypes.string,
  viewLabel: PropTypes.string,
  buyLabel: PropTypes.string,
  resultsGeneralSpecsLabel: PropTypes.string,
  resultsIdLabel: PropTypes.string,
  seeDifferencesLabel: PropTypes.string,
  onClosePopup: PropTypes.func,
  onPopProduct: PropTypes.func,
  onToggleShowDifferences: PropTypes.func,
};

ComparePopup.defaultProps = {
  productsCode: [],
  data: {},
  isOpen: false,
  showDifferences: false,
  titleLabel: 'Click here to change your selection',
  viewLabel: 'View',
  buyLabel: 'BUY NOW',
  seeDifferencesLabel: 'See differences only',
  resultsGeneralSpecsLabel: 'General specifications',
  resultsIdLabel: 'ID product',
  onClosePopup: null,
  onPopProduct: null,
  onToggleShowDifferences: null,
};

export default ComparePopup;
